module.exports = "<img [src]=\"currentImage.imgSrc\"\n     [alt]=\"currentImage.imgAlt\"\n     (click)=\"nextImage()\">"


//////////////////
// WEBPACK FOOTER
// ./src/viega-common/components/viega-image-dialog/viega-image-dialog.component.html
// module id = p2qu
// module chunks = 5